import Request from "../../lib/request";
import {
  IMAGES_API,
  PROJECT_USERS_API,
  RECEIVES_API
} from "../../constants/api";
import { PROJECT_USER_ID } from "../../constants/storageKeys";

const baseUrl = process.env.REACT_APP_API_ADMIN_URL;

export const remove = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${RECEIVES_API}/${id}`,
    needToken: true,
    data: id
  });
};

export const store = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${RECEIVES_API}`,
    needToken: true,
    data: data
  });
};

export const storeImage = (image, id) => {
  let formData = new FormData();
  formData.append("image", image);
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${RECEIVES_API}/${id}/${IMAGES_API}`,
    needToken: true,
    headers: {
      "Content-Type": "multipart/forms-data"
    },
    data: formData
  });
};
export const get = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${RECEIVES_API}/${id}`,
    needToken: true
  });
};

export const update = (id, data) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${RECEIVES_API}/${id}`,
    needToken: true,
    data: data
  });
};

export const getImage = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${RECEIVES_API}/${id}/${IMAGES_API}`,
    needToken: true
  });
};
